import { GridRecord } from '../../components/Grid/GridDataTypes';
import {
  DefaultApi,
  GetSalesInvoicePaymentSummaryDto,
} from '../autogenerated/pokApiClient';
import { salesInvoicePaymentForGrid } from '../../../pok/components/SalesInvoices/SalesInvoicePaymentsSearch';

export type { GetSalesInvoicePaymentSummaryDto };

export interface SalesInvoicePaymentsContextInterface {
  getAllByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
    invoiceNumber?: string,
  ) => Promise<GridRecord[]>;
  getAllCount: (
    filterText?: string,
    filterColumns?: string,
    invoiceNumber?: string,
  ) => Promise<number>;
  getSummary: (
    invoiceNumber: string,
  ) => Promise<GetSalesInvoicePaymentSummaryDto>;
}

export const SalesInvoicePaymentsContext = (
  api: DefaultApi,
): SalesInvoicePaymentsContextInterface => ({
  getAllByPortion: async (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
    invoiceNumber?: string,
  ) => {
    const data = await api.salesInvoicePaymentsControllerGetAllByPortion(
      pageSize,
      pageNumber,
      orderBy || '',
      orderDirection || '',
      filterText || '',
      filterColumns,
      invoiceNumber,
    );
    return data.map(salesInvoicePaymentForGrid);
  },
  getAllCount: async (
    filterText?: string,
    filterColumns?: string,
    invoiceNumber?: string,
  ) => {
    return api.salesInvoicePaymentsControllerGetAllCount(
      filterText || '',
      filterColumns,
      invoiceNumber,
    );
  },
  getSummary: async (
    invoiceNumber: string,
  ): Promise<GetSalesInvoicePaymentSummaryDto> =>
    api.salesInvoicePaymentsControllerGetSummary(invoiceNumber),
});
